export default __webpack_public_path__ + "static/media/background_video.39765699.mp4";